import React, { useState, useEffect, useContext } from "react";
import PercentRoundedIcon from "@mui/icons-material/PercentRounded";
import { useNavigate } from "react-router-dom";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getTasaMorosidadAsync } from "../../../api/Dashboard";
import KpiCard from "../../../components/ui/KpiCard";

const TasaMorosidad = ({ selectedSucursal }) => {
  const [tasa, setTasa] = useState(0);
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getTasaMorosidadAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setTasa(result.data.result);
    })();
  }, [selectedSucursal]);

  return (
    <KpiCard
      onClick={() => navigate(`${ruta}/credits`)}
      icon={<PercentRoundedIcon sx={{ fontSize: 20 }} />}
      iconBg="error.light"
      iconColor="error.main"
      value={`${tasa}%`}
      label="Tasa de morosidad"
    />
  );
};

export default TasaMorosidad;
